import axios from 'axios';
import envService from "@/services/env.service";

const BASE_URL = envService.getApiBaseUrl() + '/admin';

const SESSIONSTORAGE_CUSTOMERS = "customers";

export default {

    async getCustomers() {
        let data = sessionStorage.getItem(SESSIONSTORAGE_CUSTOMERS);
        if (data === undefined || data === null) {
            let response = await axios.get(BASE_URL + '/customers');
            if (response.status == 200) {
                sessionStorage.setItem(SESSIONSTORAGE_CUSTOMERS, JSON.stringify(response.data));
                data = response.data;
            }
        } else {
            data = JSON.parse(data);
        }
        return data;
    },
};
 